export const environment = {
  production: true,
  SSO : {
//url :  'https://sso.pdoct-congo.com/auth',
    //  url :  'http://192.168.2.136/auth',
    url :  'https://sso.pdoctcongo.com/auth',

    clientId : 'web_app' ,
    realm : 'DGTT',

  }


};
